import React, { useState } from 'react';
import { X } from 'lucide-react';
import ReferralContent from './ReferralContent';
import ReferralTermsContent from './ReferralTermsContent';

interface ReferralModalProps {
  isOpen: boolean;
  onClose: () => void;
  referralUrl: string;
  copied: boolean;
  onCopy: () => void;
}

const ReferralModal: React.FC<ReferralModalProps> = ({
  isOpen,
  onClose,
  referralUrl,
  copied,
  onCopy,
}) => {
  const [showTerms, setShowTerms] = useState(false);

  const handleClose = () => {
    setShowTerms(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="hidden lg:block fixed inset-0 z-50">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 transition-opacity duration-300"
        onClick={handleClose}
      />
      
      {/* Modal */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md transition-all duration-300">
        <div className="bg-white rounded-2xl shadow-2xl p-6 m-4 max-h-[85vh] overflow-y-auto">
          {/* Header - Only show when not in terms view */}
          {!showTerms && (
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-gray-900">Invite Friends</h3>
              <button
                onClick={handleClose}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>
          )}

          {/* Content */}
          {showTerms ? (
            <ReferralTermsContent onBack={() => setShowTerms(false)} />
          ) : (
            <ReferralContent
              referralUrl={referralUrl}
              copied={copied}
              onCopy={onCopy}
              onViewTerms={() => setShowTerms(true)}
              isMobile={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReferralModal;
